import React, { startTransition } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// #root muss geparst sein (das Bundle wird dynamisch nachgeladen und kann aus dem Cache noch im <head> laufen) – sonst React #299 → leere Seite
const mount = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  // Erstes Rendern als Transition: React arbeitet in kleinen Häppchen statt in einem langen Block (weniger Blockierzeit auf Handys);
  // das Titelbild zeigt derweil schon die statische Hülle aus index.html
  startTransition(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
};
if (document.getElementById("root")) mount(); else document.addEventListener("DOMContentLoaded", mount);
